//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import { ref, watch } from '@vue/composition-api'
import { mdiPencil, mdiCheck, mdiClose } from '@mdi/js'

export default {
  setup() {
    const activator = ref(null)
    const attach = ref(null)
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'error']
    const editing = ref()
    const editingIndex = ref(-1)
    const items = ref([
      { header: 'Select an option or create one' },
      {
        text: 'Foo',
        color: 'primary',
      },
      {
        text: 'Bar',
        color: 'error',
      },
    ])
    const nonce = ref(1)
    const menu = ref(false)
    const model = ref([
      {
        text: 'Foo',
        color: 'primary',
      },
    ])

    const search = ref()

    const edit = (index, item) => {
      if (!editing.value) {
        editing.value = item
        editingIndex.value = index
      } else {
        editing.value = null
        editingIndex.value = -1
      }
    }

    const filter = (item, queryText, itemText) => {
      if (item.header) return false

      const hasValue = val => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    }

    watch(model, (val, prev) => {
      if (val.length === prev.length) return

      model.value = val.map(v => {
        if (typeof v === 'string') {
          // eslint-disable-next-line no-param-reassign
          v = {
            text: v,
            color: colors[nonce.value - 1],
          }

          items.value.push(v)

          nonce.value += 1
        }

        return v
      })
    })

    return {
      items,
      activator,
      attach,
      editing,
      editingIndex,
      menu,
      search,
      model,
      colors,
      nonce,

      edit,
      filter,

      icons: {
        mdiPencil,
        mdiCheck,
        mdiClose,
      },
    }
  },
}
